export default {"src":"/_next/static/media/international-icon.646bf767.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};